import React, { useState, Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Menu, MenuItem, ListItemIcon, Typography } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

function ImageCardGroupMenu(props: ImageCardGroupMenuProps) {
  const classes = useStyles();
  const open = Boolean(props.anchor);

  return (
    <Fragment>
      <Menu
        className={classes.settings}
        open={open}
        anchorEl={props.anchor}
        onClose={props.handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem onClick={props.handleClickOpenDelete}>
          <Typography>Delete Image</Typography>
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
        </MenuItem>
      </Menu>
    </Fragment>
  );
}

const useStyles = makeStyles((theme) => ({
  settings: {
    padding: "0.5rem",
  },
}));

interface ImageCardGroupMenuProps {
  group: AssetItem[];
  anchor: any;
  handleClose: any;
  handleClickOpenDelete: any;
}

interface AssetItem {
  created_at: string;
  id: string;
  metadata: Metadata;
  name: string;
  physical_file_path: string;
  updated_at: string;
  url?: string; // Make this optional in case it's nested under the `asset` property.
  asset?: {
    url: string;
    physical_file_path: string;
    name: string;
  }; // Optional in case the asset details are nested inside another object.
  type?: string; // Optional in case the `type` field is used in some parts.
}

interface Metadata {
  group_id?: string;
}

export default ImageCardGroupMenu;
